<!--
 * @Description: 统计字段说明弹窗
 * @Author: xiawenlong
 * @Date: 2024-11-25 14:22:25
 * @LastEditors: xiawenlong
-->
<template>
  <a-modal
    :visible="visible"
    :footer="null"
    :closable="false"
    :mask-closable="true"
    width="700px"
    class="stats-field-dialog"
    @cancel="close"
  >
    <div class="dialog-content">
      <div class="dialog-header">
        <span class="dialog-title">统计字段说明</span>
        <img src="@/img/datav-tc/dialog_close_btn.png" alt="" class="close-btn" @click="close" />
      </div>
      <div class="dialog-body">
        <div class="field-list">
          <div class="field-item">
            <span class="field-name">商品数量：</span>
            <span class="field-desc">校园餐商品中录入的商品数量</span>
          </div>
          <div class="field-item">
            <span class="field-name">学校数量：</span>
            <span class="field-desc">校园餐订单中下单过的学校数量</span>
          </div>
          <div class="field-item">
            <span class="field-name">采购订单：</span>
            <span class="field-desc">校园餐中所有采购订单的数量</span>
          </div>
          <div class="field-item">
            <span class="field-name">学校累计采购金额：</span>
            <span class="field-desc">校园餐中所有采购订单的采购金额总数</span>
          </div>
          <div class="field-item">
            <span class="field-name">万象销售金额：</span>
            <span class="field-desc">校园餐中所有供应商订单的仓库入库价之和</span>
          </div>
          <div class="field-item">
            <span class="field-name">俪丰销售金额：</span>
            <span class="field-desc">校园餐中所有俪丰的采购订单的采购金额总数</span>
          </div>
          <div class="field-item">
            <span class="field-name">联农销售金额：</span>
            <span class="field-desc">校园餐中所有联农的采购订单的采购金额总数</span>
          </div>
          <div class="field-item">
            <span class="field-name">联合体毛利润：</span>
            <span class="field-desc">校园餐中俪丰和联农的毛利润总和</span>
          </div>
          <div class="field-item">
            <span class="field-name">万象毛利润：</span>
            <span class="field-desc">校园餐中供应商订单的仓库入库价减去供应商报价</span>
          </div>
          <div class="field-item">
            <span class="field-name">俪丰/联农毛利润：</span>
            <span class="field-desc">各自采购订单价格减去仓库入库价格</span>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="close-text" @click="close">关闭</div>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'StatsFieldDialog',
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.stats-field-dialog {
  ::v-deep .ant-modal-content {
    background: url('~@/img/datav-tc/dialog_bg_s.png') no-repeat center;
    background-size: 100% 100%;
    border: none;
    box-shadow: none;
  }

  ::v-deep .ant-modal-body {
    padding: 0;
  }

  .dialog-content {
    padding: 30px 40px;
    color: #fff;

    .dialog-header {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-bottom: 30px;

      .dialog-title {
        font-size: 28px;
        font-weight: bold;
        color: #ecf8ff;
      }

      .close-btn {
        position: absolute;
        right: 0;
        top: 0;
        width: 40px;
        height: 40px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }

    .dialog-body {
      // max-height: 500px;
      // overflow-y: auto;

      .field-list {
        .field-item {
          display: flex;
          padding: 12px 0;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          font-size: 16px;
          line-height: 1.6;

          &:last-child {
            border-bottom: none;
          }

          .field-name {
            color: #00c0fe;
            font-weight: bold;
            min-width: 160px;
            flex-shrink: 0;
          }

          .field-desc {
            color: #dae3f6;
            flex: 1;
          }
        }
      }
    }

    .dialog-footer {
      margin-top: 30px;
      padding-top: 20px;
      border-top: 1px solid rgba(255, 255, 255, 0.2);
      text-align: center;

      .close-text {
        display: inline-block;
        padding: 10px 40px;
        font-size: 18px;
        color: #00c0fe;
        border: 1px solid #00c0fe;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          background: rgba(0, 192, 254, 0.2);
          color: #66ffff;
        }
      }
    }
  }
}
</style>
